import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** Selected/active treatment: brand-tinted border and glow. */
  glow?: boolean;
}

// Cards never set their own outer margin — the parent's `space-y-*` or
// ResponsiveGrid gap owns spacing, so two adjacent cards can't disagree.
export function Card({ glow = false, className, ...props }: CardProps) {
  return <div className={cn(glow ? 'card-glow' : 'card', className)} {...props} />;
}
